module.exports = __webpack_public_path__ + "static/media/error.3af5fe91.png";